import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getKpiForTable',
    standalone: false
})
export class GetKpiForTablePipe implements PipeTransform {
  private static round(myNumber, decimals) {
    decimals = decimals || 0;
    return (Math.round(myNumber * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
  }

  transform(element: any, index: number, round: boolean = true, excelFormat:boolean = false): any {
    const kpi = element.find(e => e.index === index);
    if (!kpi) {
      return false;
    }
    if (!kpi.value && !Number.isInteger(kpi.value)) {
      return false;
    }
    let decimals = 2;
    if (kpi.symbol === 'MWh') {
      decimals = 3;
    }
    let value = kpi.value;
    if(excelFormat && kpi.symbol === '%'){
      value = kpi.value / 100;
      decimals = 4;
    }
    return round ? GetKpiForTablePipe.round(value, decimals) : kpi.value;
  }
}
